/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSelectComponent', [
    'DesignerComponent',
    'DesignerSchema',

    function (DesignerComponent, DesignerSchema) {
      function DesignerSelectComponent() {
        DesignerComponent.apply(this);

        this.fields = null;
      }

      DesignerSelectComponent.prototype = new DesignerComponent();

      DesignerSelectComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          fields: this.fields || [],
        });

        return data;
      };

      DesignerSelectComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerSelectComponent.prototype.setData = function (data) {
        this.fields = data.fields;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerSelectComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();

        schema.id = this.id;
        schema.name = this.name;

        _.each(this.fields, function (field) {
          schema.addField({
            name: field.projected_name,
          });
        });

        return schema;
      };

      return DesignerSelectComponent;
    },
  ]);
})(window.angular);
